import React from "react";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";
import FooterBlack from "components/Footers/FooterBlack.js";

function Consulting() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="edge-page">
      <div className="edge-page-brand-nav">
        <Container>
          <Link to="/presentation">Edge<span>Ventures</span></Link>
        </Container>
      </div>
      <section className="edge-page-hero">
        <Container>
          <span className="edge-page-eyebrow">{"// expertise"}</span>
          <h1 className="edge-page-title">
            Data <span>Consulting</span>
          </h1>
          <p className="edge-page-subtitle">
            Senior data architecture for enterprise and growth-stage teams.
            Snowflake, dbt, Airflow, and cloud-native stacks — designed for
            long-term maintainability, not just the immediate sprint.
          </p>
          <Link to="/contact" className="ep-btn-primary">
            Discuss Your Stack →
          </Link>
        </Container>
      </section>

      <section className="edge-page-body">
        <Container>
          <div className="edge-stub-card">
            <div className="edge-stub-icon">
              <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
              </svg>
            </div>
            <h3>Engagement details coming soon</h3>
            <p>
              We're putting together case studies on past engagements across
              healthcare, media, and financial services. In the meantime, reach
              out directly to discuss scope and availability.
            </p>
            <Link to="/contact" className="ep-btn-primary">
              Get in touch
            </Link>
          </div>
        </Container>
      </section>

      <FooterBlack />
    </div>
  );
}

export default Consulting;
